module.exports = __webpack_public_path__ + "static/media/special-event.aa055989.jpg";